import $ from 'jquery';

// TODO make this more general that dropdown buttons can be used everywhere?
$(document).ready(() => {
  const brandhubDropdownButtons = $('*[data-js-init="brandhub-dropdown-button"]');
  brandhubDropdownButtons.each((i, e) => {
    const self = {
      elem: $(e),
      btn: $(e).find('> .btn'),
      dropdown: $(e).find('> .dropdown-menu'),
      sliderItemOverlay: $(e).closest('.brandhub-slider-item-overlay'),
      sliderList: $(e).closest('.brandhub-slider-list'),
      isFirstShow: true,
      init () {
        self.btn.on('click', (evt) => {
          evt.preventDefault();
          self.toggle();
        });
        self.sliderItemOverlay.on('click', (evt) => {
          if (!$(evt.target).hasClass('btn') && self.dropdown.is(':not(:hidden)') === true) {
            evt.preventDefault();
            self.hide();
          }
        });
        self.sliderList.on('beforeChange', () => {
          self.hide();
        });
        $(window).on('resize', () => {
          self.reposition();
        });
      },
      toggle () {
        if (self.isFirstShow) {
          self.isFirstShow = false;
          self.appendToBody();
        }
        self.reposition();
        self.dropdown.toggle();
      },
      hide () {
        self.dropdown.hide();
      },
      appendToBody () {
        self.dropdown.appendTo('body');
      },
      reposition () {
        const offsetLeft = self.elem.offset().left;
        const offsetTop = self.elem.offset().top + self.elem.height() + 2;
        const minWidth = self.btn.outerWidth();
        self.dropdown.css({
          position: 'absolute',
          left: offsetLeft,
          top: offsetTop,
          'min-width': minWidth,
          'z-index': 99,
        });
      },
    };
    self.init();
  });
});



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/common/js/dropdownbutton/dropdownbutton.js